<template>
  <v-app id="example-2" dark toolbar>
    <v-navigation-drawer clipped persistent dark :mini-variant.sync="mini" v-model="drawer" overflow>
      <sidebar></sidebar>
    </v-navigation-drawer>
    <v-toolbar fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>QikByte</v-toolbar-title>
    </v-toolbar>
    <main class="one">
      <messages></messages>
    </main>
  </v-app>
</template>

<script>
import Sidebar from '@/components/sidebar/Sidebar'
import Messages from '@/components/messages/Messages'

export default {
  components: { Sidebar, Messages },
  data () {
    return {
      drawer: false,
      items: [],
      mini: false,
      right: null
    }
  }
}
</script>

<style lang="stylus">
  @import '../stylus/main'
  main.one
    overflow: auto
    padding-bottom: 200px
</style>



// WEBPACK FOOTER //
// Dash.vue?2fbf50be